"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ULIDEventIDGenerator = void 0;
var ulid_1 = require("ulid");
var ulid = ulid_1.monotonicFactory();
var EventIDPrefix = 'gsuevent:';
function ULIDEventIDGenerator() {
    function generateEventId() {
        return "" + EventIDPrefix + ulid();
    }
    return {
        generateEventId: generateEventId,
    };
}
exports.ULIDEventIDGenerator = ULIDEventIDGenerator;
//# sourceMappingURL=event-id.js.map